import React, { useState } from 'react';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseTextField from './ExpenseTextField';

const ExpenseDescription = (props) => {
    const { index, expense, isViewOnly } = props;
    const { control, errors } = useFormContext();
    const maxLength = 100;
    let helperText = null;

    if (errors.expenseEntries?.[index]?.description?.message)
        helperText = errors.expenseEntries?.[index]?.description?.message;

    return (
        <Grid2 item size={{ xs: 12 }}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].description`}
                defaultValue={expense.description}
                render={({ onChange, value }) => (
                    <ExpenseTextField
                        multiline
                        inputProps={{ maxLength }}
                        minRows={1}
                        id={`description${index}`}
                        onChange={onChange}
                        value={value}
                        disabled={isViewOnly}
                        label="Description"
                        error={Boolean(errors.expenseEntries?.[index]?.description)}
                        helperText={
                            helperText ?? value ? `${value.length} of ${maxLength} characters` : ''
                        }
                        placeholder="Description will appear on client invoices"
                        slotProps={{
                            input: {
                                sx: {
                                    height: 'auto',
                                    fontSize: '14px',
                                    padding: '10px 12px !important',
                                },
                            },
                        }}
                        FormHelperTextProps={{
                            sx: {
                                textAlign: 'right',
                                width: '100%',
                                margin: 0,
                            },
                        }}
                        sx={{
                            '& .MuiInputBase-root': {
                                marginTop: '0',
                            },
                            '& .MuiInputLabel-shrink': {
                                transform: 'translate(0, 1.5px) scale(0.75) !important',
                            },
                            '& .MuiInputBase-root::before': { borderBottom: 'none !important' },
                            '& .MuiInputBase-root::after': { borderBottom: 'none !important' },
                        }}
                    />
                )}
            />
        </Grid2>
    );
};

export default ExpenseDescription;
